import * as React from "react";

interface IHomeButtonProps {
  handleClick: () => void;
}

class HomeButton extends React.Component<IHomeButtonProps> {
  constructor(props: IHomeButtonProps) {
    super(props);
  }

  public render() {
    return (
      <a onClick={this.props.handleClick}>
        <svg
          className="home-button"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          viewBox="0 0 99.227 98.287"
        >
          <path
            fill="#5D87C0"
            d="M91.5,34.1c-1.2-0.9-1.8-2.4-1.6-4c1.2-10.4-6.3-20-16.9-21.2c-1.5-0.2-3-0.2-4.4,0c-1.5,0.2-3-0.4-4-1.6
	C58-1,45.9-2.4,37.6,4.2c-1.2,0.9-2.2,2-3.1,3.1c-0.9,1.2-2.4,1.8-4,1.6C20,7.7,10.5,15.2,9.2,25.8c-0.2,1.5-0.2,3,0,4.4
	c0.2,1.5-0.4,3-1.6,4c-8.3,6.6-9.7,18.7-3.1,27c0.9,1.2,2,2.2,3.1,3.1c1.2,0.9,1.8,2.4,1.6,3.9C8,78.7,15.6,88.3,26.1,89.5
	c1.5,0.2,3,0.2,4.4,0c1.5-0.2,3,0.4,4,1.6c6.6,8.3,18.7,9.7,27,3.1c1.2-0.9,2.2-2,3.1-3.1c1-1.2,2.5-1.8,4-1.6
	c10.5,1.2,20.1-6.3,21.3-16.9c0.2-1.5,0.2-3,0-4.4c-0.2-1.5,0.4-3,1.6-3.9c4.6-3.7,7.3-9.2,7.3-15.1C98.8,43.3,96.1,37.8,91.5,34.1z
	 M68.3,68.1c0,1.3-1.1,2.4-2.4,2.4H33.7c-1.3,0-2.4-1.1-2.4-2.4V51.4c0-1.1,0.9-2,2-2s2,0.9,2,2v15.2h29V51.4c0-1.1,0.9-2,2-2
	s2,0.9,2,2V68.1z M77,51.8c-0.4,0.4-0.9,0.6-1.4,0.6s-1-0.2-1.4-0.6L49.7,27.3L25.2,51.8c-0.8,0.8-2,0.8-2.8,0c-0.8-0.8-0.8-2,0-2.8
	L48,23.4c0.9-0.9,2.5-0.9,3.4,0L77,49C77.8,49.8,77.8,51,77,51.8z"
          />
        </svg>
      </a>
    );
  }
}

export default HomeButton;



// WEBPACK FOOTER //
// ./src/common/menu/components/HomeButton.tsx